module.exports = __webpack_public_path__ + "img/solar.59bf2b37.png";